import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch } from "vue";
import FindContactModal from "./find-contact-modal.vue";
import { useRouter } from "vue-router";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { RouteNames } from "@/router/RouteNames";
import { useContactRecordNavigationStore } from "@/stores/record-navigation/ContactRecordNavigationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-contact',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * Controls the visibility of the "New Contact" button.
   * @type {Boolean}
   * @default false (button is hidden)
   */
  showNewContactButton: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the user clicks to open the new contact creation modal.
   * Used to initiate the creation of a new contact.
   */
  "openNewContactModal",
],
  setup(__props, { emit }) {

const props = __props;

const contactRecordNavigationStore = useContactRecordNavigationStore();





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => props.modelValue,
  () => {
    /* If the screen is shown again, we should Clear the cached Record Navigation Store ready for new Navigation */
    if (props.modelValue) {
      contactRecordNavigationStore.clear();
    }
  },
);

const router = useRouter();

/** Loads the selected contact */
const onContactSelected = (
  contact: ContactFindResult,
  ids: number[],
  index: number,
) => {
  if (!contact?.id) {
    return;
  }

  /* Cache the contacts for the Record Navigation before loading the contact record
   * So that we can navigate between records using next/previous buttons on the contact record */
  contactRecordNavigationStore.cacheContacts(ids, index);

  router.push({
    name: RouteNames.ContactPage,
    params: { contactid: contact.id.toString() },
  });
};

const onPrimarySelected = (primaryId: number) => {
  if (!primaryId) {
    return;
  }

  contactRecordNavigationStore.cacheContacts([primaryId], 0);

  router.push({
    name: RouteNames.ContactPage,
    params: { contactid: primaryId.toString() },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FindContactModal, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    onContactSelected: onContactSelected,
    onPrimaryContactSelected: onPrimarySelected,
    onOpenNewContactModal: _cache[1] || (_cache[1] = ($event: any) => (emit('openNewContactModal'))),
    showNewContactButton: props.showNewContactButton
  }, null, 8, ["modelValue", "showNewContactButton"]))
}
}

})